(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jl-collection-grid"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    var form = event.target.closest('.jl-filters-form');
    if (form) {
      form.submit();
    }
  });

  function jlSyncFilterGroups() {
    var isDesktop = window.matchMedia('(min-width: 901px)').matches;
    document.querySelectorAll('.jl-filter-group').forEach(function (details) {
      details.open = isDesktop;
    });
  }

  jlSyncFilterGroups();
  window.addEventListener('resize', jlSyncFilterGroups);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jl-header"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var searchToggle = document.getElementById('jl-search-toggle');
    var searchPanel = document.getElementById('jl-search-panel');
    var burger = document.querySelector('.jl-burger');
    var mobileNav = document.getElementById('jl-mobile-nav');

    if (searchToggle && searchToggle.contains(event.target)) {
      var isHidden = searchPanel.hasAttribute('hidden');
      if (isHidden) {
        searchPanel.removeAttribute('hidden');
      } else {
        searchPanel.setAttribute('hidden', '');
      }
      searchToggle.setAttribute('aria-expanded', String(isHidden));
    }

    if (burger && burger.contains(event.target)) {
      var navHidden = mobileNav.hasAttribute('hidden');
      if (navHidden) {
        mobileNav.removeAttribute('hidden');
      } else {
        mobileNav.setAttribute('hidden', '');
      }
      burger.setAttribute('aria-expanded', String(navHidden));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jl-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.jl-product');
    if (!section) return;

    var variantsData = JSON.parse(section.querySelector('[data-jl-variants]').textContent);
    var optionNames = JSON.parse(section.querySelector('[data-jl-option-names]').textContent);
    var colorOptionName = section.dataset.colorOption;
    var form = section.querySelector('#jl-product-form');
    var variantInput = section.querySelector('[data-jl-variant-input]');
    var priceEl = section.querySelector('[data-jl-price]');
    var compareEl = section.querySelector('[data-jl-price-compare]');
    var submitBtn = section.querySelector('[data-jl-add-to-cart]');
    var submitLabel = section.querySelector('[data-jl-submit-label]');
    var stickyBar = section.querySelector('[data-jl-sticky-cta]');
    var stickyPrice = section.querySelector('[data-jl-sticky-price]');
    var stickySubmit = section.querySelector('[data-jl-sticky-submit]');
    var stickyLabel = section.querySelector('[data-jl-sticky-label]');
    var stockNote = section.querySelector('[data-jl-stock-note]');
    var bundleToggle = section.querySelector('[data-jl-bundle-toggle]');
    var bundlePicker = section.querySelector('[data-jl-bundle-picker]');
    var shippingEl = section.querySelector('[data-jl-shipping-progress]');

    // Reveal the sticky bar only once the real add-to-cart button scrolls out of view,
    // so there is always exactly one reachable add-to-cart on mobile.
    if (stickyBar && submitBtn) {
      // Deliberately not rAF-throttled: this is the add-to-cart, and a rect read plus a
      // class toggle is cheap enough to run inline on scroll.
      function updateStickyBar() {
        var rect = submitBtn.getBoundingClientRect();
        var inView = rect.bottom > 0 && rect.top < window.innerHeight;
        stickyBar.classList.toggle('is-visible', !inView);
      }

      updateStickyBar();
      document.addEventListener('scroll', updateStickyBar, { capture: true, passive: true });
      window.addEventListener('resize', updateStickyBar);
      window.addEventListener('load', updateStickyBar);
    }

    var slides = section.querySelectorAll('[data-jl-slide]');
    var thumbs = section.querySelectorAll('[data-jl-thumb]');
    var thumbStrip = section.querySelector('[data-jl-thumbs]');
    var activeIndex = 0;

    function showSlide(next) {
      if (slides.length < 2) return;
      activeIndex = (next + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === activeIndex);
      });

      thumbs.forEach(function (thumb, i) {
        var on = i === activeIndex;
        thumb.classList.toggle('is-active', on);
        if (on) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });

      var activeThumb = thumbs[activeIndex];
      if (activeThumb && thumbStrip) {
        var target = activeThumb.offsetLeft - (thumbStrip.clientWidth - activeThumb.clientWidth) / 2;
        var maxScroll = thumbStrip.scrollWidth - thumbStrip.clientWidth;
        thumbStrip.scrollTo({
          left: Math.max(0, Math.min(target, maxScroll)),
          behavior: 'smooth',
        });
      }
    }

    section.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-jl-thumb]');
      if (thumb) {
        showSlide(parseInt(thumb.getAttribute('data-jl-thumb'), 10));
        return;
      }
      if (event.target.closest('[data-jl-prev]')) showSlide(activeIndex - 1);
      if (event.target.closest('[data-jl-next]')) showSlide(activeIndex + 1);
    });

    var selected = {};
    section.querySelectorAll('.jl-pdp-option').forEach(function (optionEl) {
      var index = optionEl.getAttribute('data-jl-option-index');
      var activeBtn = optionEl.querySelector('.is-selected');
      if (activeBtn) {
        selected[index] = activeBtn.getAttribute('data-jl-option-value');
      }
    });

    function findVariant(selectedValues) {
      return variantsData.find(function (variant) {
        return optionNames.every(function (name, i) {
          return variant.options[i] === selectedValues[i];
        });
      });
    }

    function selectedValuesArray() {
      return optionNames.map(function (name, i) {
        return selected[i];
      });
    }

    // Keeps the in-page button, the mobile sticky bar and the note in step, so the
    // sold-out state reads the same way on every screen size.
    function setBuyable(buyable, price) {
      if (buyable) {
        submitBtn.removeAttribute('disabled');
        submitLabel.textContent = submitLabel.dataset.addLabel + ' — ' + formatMoney(price);
      } else {
        submitBtn.setAttribute('disabled', '');
        submitLabel.textContent = submitLabel.dataset.soldOutLabel;
      }

      if (stickySubmit && stickyLabel) {
        if (buyable) {
          stickySubmit.removeAttribute('disabled');
          stickyLabel.textContent = stickyLabel.dataset.addLabel;
        } else {
          stickySubmit.setAttribute('disabled', '');
          stickyLabel.textContent = stickyLabel.dataset.soldOutLabel;
        }
      }

      if (stockNote) stockNote.hidden = buyable;
    }

    function updateUi(variant) {
      // No variant means the chosen combination doesn't exist at all — still not buyable.
      if (!variant) {
        setBuyable(false, 0);
        return;
      }

      variantInput.value = variant.id;
      priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) compareEl.textContent = formatMoney(variant.compare_at_price);
      } else if (compareEl) {
        compareEl.textContent = '';
      }

      setBuyable(variant.available, variant.price);
    }

    // Liquid can only mark option values that have no variant at all. Stock depends on
    // the whole combination, so recompute it here whenever the selection changes.
    function markButton(btn, variant) {
      var missing = !variant;
      var soldOut = !!variant && !variant.available;

      btn.classList.toggle('is-unavailable', missing);
      btn.classList.toggle('is-sold-out', soldOut);

      if (missing || soldOut) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    }

    function sizeOptionIndex() {
      return optionNames.findIndex(function (name) {
        return name.toLowerCase() !== colorOptionName;
      });
    }

    function refreshOptionAvailability() {
      var current = selectedValuesArray();

      section.querySelectorAll('.jl-pdp-option').forEach(function (optionEl) {
        var index = parseInt(optionEl.getAttribute('data-jl-option-index'), 10);

        optionEl.querySelectorAll('[data-jl-option-value]').forEach(function (btn) {
          var candidate = current.slice();
          candidate[index] = btn.getAttribute('data-jl-option-value');
          markButton(btn, findVariant(candidate));
        });
      });

      // The second-size picker holds its own copy of the size buttons.
      if (bundlePicker) {
        var sizeIndex = sizeOptionIndex();
        bundlePicker.querySelectorAll('[data-jl-bundle-value]').forEach(function (btn) {
          var candidate = current.slice();
          if (sizeIndex > -1) {
            candidate[sizeIndex] = btn.getAttribute('data-jl-bundle-value');
          }
          markButton(btn, findVariant(candidate));
        });
      }
    }

    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    section.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-jl-option-value]');
      if (btn && !btn.hasAttribute('data-jl-bundle-value')) {
        var optionEl = btn.closest('.jl-pdp-option');
        var index = optionEl.getAttribute('data-jl-option-index');
        optionEl.querySelectorAll('[data-jl-option-value]').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        selected[index] = btn.getAttribute('data-jl-option-value');
        var variant = findVariant(selectedValuesArray());
        updateUi(variant);
        refreshOptionAvailability();
      }

      var bundleBtn = event.target.closest('[data-jl-bundle-value]');
      if (bundleBtn) {
        // No label here to report "sold out" on, so just don't allow picking one.
        if (bundleBtn.getAttribute('aria-disabled') === 'true') return;
        bundlePicker.querySelectorAll('[data-jl-bundle-value]').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        bundleBtn.classList.add('is-selected');
      }
    });

    if (bundleToggle) {
      bundleToggle.addEventListener('change', function () {
        bundlePicker.hidden = !bundleToggle.checked;
      });
    }

    function refreshShipping() {
      if (!shippingEl) return;
      var threshold = parseInt(shippingEl.getAttribute('data-threshold'), 10);
      if (!threshold) return;

      fetch('/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var textEl = shippingEl.querySelector('[data-jl-shipping-text]');
          var barEl = shippingEl.querySelector('[data-jl-shipping-bar]');
          var remaining = threshold - cart.total_price;
          if (remaining <= 0) {
            textEl.textContent = shippingEl.dataset.unlockedText || 'Free shipping unlocked';
            barEl.style.width = '100%';
          } else {
            var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
            barEl.style.width = pct + '%';
            textEl.textContent = shippingEl.dataset.progressText.replace('{amount}', formatMoney(remaining));
          }
        });
    }

    refreshShipping();
    refreshOptionAvailability();
    updateUi(findVariant(selectedValuesArray()));

    function submitForm(event) {
      if (event) event.preventDefault();
      if (submitBtn.hasAttribute('disabled')) return;
      var items = [{ id: parseInt(variantInput.value, 10), quantity: 1 }];

      if (bundleToggle && bundleToggle.checked) {
        var bundleActive = bundlePicker.querySelector('[data-jl-bundle-value].is-selected');
        if (bundleActive) {
          var bundleValues = selectedValuesArray().slice();
          var sizeIndex = sizeOptionIndex();
          if (sizeIndex > -1) {
            bundleValues[sizeIndex] = bundleActive.getAttribute('data-jl-bundle-value');
          }
          var bundleVariant = findVariant(bundleValues);
          if (bundleVariant && bundleVariant.available) {
            items.push({ id: bundleVariant.id, quantity: 1 });
          }
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var bubble = document.getElementById('jl-cart-count');
          if (bubble) {
            bubble.textContent = cart.item_count;
            bubble.hidden = cart.item_count === 0;
          }
          refreshShipping();
        });
    }

    if (form) form.addEventListener('submit', submitForm);
    if (stickySubmit) stickySubmit.addEventListener('click', submitForm);

    var sizeGuideOpen = section.querySelector('[data-jl-size-guide-open]');
    var sizeGuideDialog = section.querySelector('[data-jl-size-guide-dialog]');
    var sizeGuideClose = section.querySelector('[data-jl-size-guide-close]');
    if (sizeGuideOpen && sizeGuideDialog) {
      sizeGuideOpen.addEventListener('click', function () {
        sizeGuideDialog.showModal();
      });
    }
    if (sizeGuideClose && sizeGuideDialog) {
      sizeGuideClose.addEventListener('click', function () {
        sizeGuideDialog.close();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
